<div [class]="previewShellWidthClass(mode())">
  <div
    class="overflow-visible bg-white"
    [ngStyle]="themeCssVars(form().themeColor)">
    @if (form().coverImageUrl) {
      <img
        [src]="form().coverImageUrl"
        alt=""
        class="h-40 w-full object-cover sm:h-48" />
    }
    <div class="p-6 sm:p-8">
      <div class="px-3">
        <div class="min-w-0 border-b border-slate-100 pb-4">
          <h3 class="text-2xl font-medium tracking-tight text-slate-950">{{ form().title }}</h3>
          @if (form().description) {
            <p class="mt-1 text-sm leading-6 text-slate-500">{{ form().description }}</p>
          }
        </div>
      </div>

      @if (answerSession(); as session) {
        @if (activePage(); as page) {
          @if (page.title || page.description) {
            <div class="mt-5 rounded-2xl bg-slate-100/90 px-5 py-4">
              @if (page.title) {
                <h4 class="text-base font-semibold tracking-tight text-slate-900">
                  {{ page.title }}
                </h4>
              }
              @if (page.description) {
                <p
                  class="text-sm leading-6 text-slate-500"
                  [class.mt-1]="!!page.title">
                  {{ page.description }}
                </p>
              }
            </div>
          }
        }

        <form class="contents" [signalForm]="session.form">
          <div class="mt-6 flex flex-col gap-3">
            @for (field of fields(); track field.id) {
              <div class="flex w-full flex-col gap-1.5 rounded-xl px-3 py-2">
                <app-form-field-preview-control
                  [field]="field"
                  [previewMode]="mode()"
                  [inputAppearance]="form().inputAppearance ?? 'fill'"
                  [previewMode]="mode()"
                  [readonly]="false"
                  [answerField]="fieldAnswerControl(field.id)"
                  [publicContext]="publicContext()" />
              </div>
            } @empty {
              <p class="px-3 py-6 text-center text-sm text-slate-500">
                No fields on this page.
              </p>
            }
          </div>

          @if (showPageIndicator()) {
            <p class="mt-6 px-3 text-center text-xs font-medium text-slate-500">
              {{ pageIndicator() }}
            </p>
          }

          <div
            class="mt-4 flex items-center gap-3"
            [class.mt-8]="!showPageIndicator()">
            @if (!isFirstPage()) {
              <button
                type="button"
                class="min-w-0 flex-1 cursor-pointer rounded-xl border border-slate-200 bg-white py-3 text-sm font-medium text-slate-800 transition hover:bg-slate-50"
                (click)="goBack()">
                {{ backLabel() }}
              </button>
            }
            <button
              type="button"
              class="min-w-0 flex-1 cursor-pointer rounded-xl py-3 text-sm font-medium text-white transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-60"
              [style.background-color]="themeAccentHex(form().themeColor)"
              [disabled]="submitting()"
              (click)="onPrimary()">
              {{ submitting() ? 'Submitting…' : primaryLabel() }}
            </button>
          </div>
        </form>
      }
    </div>
  </div>
</div>
